import * as React from "react";
import { useMemo, useRef } from "react";
import { useMenu } from "../../Menu/useMenu";
import { useUser } from "../../user/useUser";
import { hrefToDashes } from "../../utils";

export function FreeTrialButton() {
  const { freeTrial, becomeMemberPayment } = useMenu().items;
  const { loggedIn, hasSubscription, user } = useUser();
  const elRef = useRef<HTMLAnchorElement>();

  let label = freeTrial.label;
  let href = freeTrial.href;

  const shouldComponentRender = useMemo(
    () => !loggedIn || !hasSubscription || user,
    [loggedIn, hasSubscription, user]
  );

  if (!shouldComponentRender) return null;

  if (loggedIn && !hasSubscription) {
    label = becomeMemberPayment.label;
    href = becomeMemberPayment.href;
  }

  return (
    <a
      aria-label={label}
      title={label}
      tabIndex={0}
      ref={elRef}
      data-track-label={`link:${hrefToDashes(href)}`}
      href={href}
      className="hide_in_app focus:elm-outline-none elm-pointer-events-auto elm-no-underline elm-py-2 elm-block elm-bg-dd-green-900 lg:hover:elm-bg-dd-green-800 elm-text-white lg:hover:elm-text-white elm-rounded-full elm-text-xs elm-font-semibold elm-px-4 elm-text-center"
    >
      {label}
    </a>
  );
}
